import { useEffect, useRef } from 'react';

const LocationTracker = () => {
  const retryIntervalRef = useRef(null);

  useEffect(() => {
    /* 🔁 keep checking localStorage until gps_location exists */
    const tryGetLocation = () => {
      const stored = localStorage.getItem('gps_location');
      if (stored) {
        // console.log('📍 Found gps_location:', JSON.parse(stored));
        clearInterval(retryIntervalRef.current); // stop polling
      } else {
        // console.log('⏳ Waiting for gps_location...');
      }
    };

    retryIntervalRef.current = setInterval(tryGetLocation, 1000); // every 1 s

    /* 🌐 location event from React Native WebView */
    const handle = (e) => {
      const loc = e.detail;                       // { lat, lng }
      localStorage.setItem('gps_location', JSON.stringify(loc));
      console.log('🌐 Received location from native:', loc);
    };

    window.addEventListener('nativeLocationUpdate', handle);

    return () => {
      window.removeEventListener('nativeLocationUpdate', handle);
      if (retryIntervalRef.current) clearInterval(retryIntervalRef.current);
    };
  }, []);

  return null; // logic-only component
};

export default LocationTracker;
